import { Component, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

/**
 * Custom Toast Component for accessibility improvements
 * Extends ngx-toastr's Toast to provide:
 * - Automatic focus on the close button for keyboard users
 * - Proper accessibility attributes (tabindex, role)
 * - Close button visibility and interaction
 */

@Component({
  selector: 'zbp-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  standalone: false
})
export class CustomToastComponent extends Toast implements AfterViewInit {
  @ViewChild('closeBtn', { read: ElementRef }) closeBtn: ElementRef | null = null;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    protected ngZone?: NgZone
  ) {
    super(toastrService, toastPackage, ngZone);
  }

  ngAfterViewInit(): void {
    // Focus the close button after view initialization
    // This ensures keyboard users can immediately interact with the close button
    this.focusCloseButton();
  }

  private focusCloseButton(): void {
    if (this.closeBtn) {
      setTimeout(() => {
        this.closeBtn?.nativeElement?.focus({ preventScroll: true });
      }, 0);
    }
  }
}




